import { appAssets } from "../config/assets";

export type StandingRow = {
    rank: number;
    team: string;
    logo: string;
    played: number;
    wins: number;
    draws: number;
    losses: number;
    goalsFor: number;
    goalsAgainst: number;
    goalDiff: number;
    points: number;
};

export const standingsGroupA: StandingRow[] = [
    {
        rank: 1,
        team: "Cap Vert",
        logo: appAssets.teams.capvert,
        played: 3,
        wins: 2,
        draws: 1,
        losses: 0,
        goalsFor: 10,
        goalsAgainst: 2,
        goalDiff: 12,
        points: 7,
    },
    {
        rank: 2,
        team: "Lions Ind.",
        logo: appAssets.teams.lions,
        played: 4,
        wins: 2,
        draws: 0,
        losses: 2,
        goalsFor: 12,
        goalsAgainst: 6,
        goalDiff: 6,
        points: 6,
    },
    {
        rank: 3,
        team: "Camerlux",
        logo: appAssets.teams.camerlux,
        played: 4,
        wins: 2,
        draws: 0,
        losses: 2,
        goalsFor: 14,
        goalsAgainst: 9,
        goalDiff: 5,
        points: 6,
    },
    {
        rank: 4,
        team: "Hespérance",
        logo: appAssets.teams.hesper,
        played: 3,
        wins: 0,
        draws: 0,
        losses: 3,
        goalsFor: 1,
        goalsAgainst: 29,
        goalDiff: -28,
        points: 0,
    },
];

export const standingsGroupB: StandingRow[] = [
    {
        rank: 1,
        team: "Guinée",
        logo: appAssets.teams.guinee,
        played: 4,
        wins: 3,
        draws: 1,
        losses: 0,
        goalsFor: 13,
        goalsAgainst: 8,
        goalDiff: 5,
        points: 10,
    },
    {
        rank: 2,
        team: "Thionville",
        logo: appAssets.teams.fpm237,
        played: 4,
        wins: 3,
        draws: 0,
        losses: 1,
        goalsFor: 16,
        goalsAgainst: 12,
        goalDiff: 4,
        points: 9,
    },
    {
        rank: 3,
        team: "Sénégal",
        logo: appAssets.teams.senegal,
        played: 3,
        wins: 1,
        draws: 0,
        losses: 2,
        goalsFor: 8,
        goalsAgainst: 6,
        goalDiff: 2,
        points: 3,
    },
    {
        rank: 4,
        team: "Gambie",
        logo: appAssets.teams.gambie,
        played: 3,
        wins: 1,
        draws: 0,
        losses: 2,
        goalsFor: 7,
        goalsAgainst: 7,
        goalDiff: 0,
        points: 3,
    },
    {
        rank: 5,
        team: "Soudan",
        logo: appAssets.teams.soudan,
        played: 4,
        wins: 0,
        draws: 1,
        losses: 3,
        goalsFor: 8,
        goalsAgainst: 17,
        goalDiff: -9,
        points: 1,
    },
];

export const groupANote =
    "Diekirch a été disqualifiée en cours de saison. Les résultats déjà joués ont été maintenus.";